export default __webpack_public_path__ + "static/media/chart.83928a71.png";